import * as constants from "../../constants";
import { ISetMoreAction } from "../../types";

export const setMore = (data: boolean): ISetMoreAction => ({
  type: constants.ACTION_SET_MORE,
  payload: data,
});
